import React, {useState} from 'react';
import {Link} from 'react-router-dom';
import AurDialog from '../../../common/aur-dialog/AurDialog';

const Dialog: React.FC = () => {
  const [isVisible, setIsVisible] = useState(true);

  const modalOkClickHandler = () => {
    setIsVisible(false);
    alert('Ok button clicked');
  };

  const modalCancelClickHandler = () => {
    setIsVisible(false);
    alert('Cancel button clicked');
  };

  const showDialog = () => {
    setIsVisible(true);
  };

  return (
    <>
      <div style={{marginBottom: '64px'}}>
        <h1>Dialog</h1>
        <div>
          Dialogs inform users about a task and can contain critical
          information, require decisions, or involve multiple tasks.
        </div>
        <Link to="/demo">Return</Link>
        <hr />
        <div style={{marginBottom: '32px'}}>
          <div onClick={showDialog}>Open Dialog</div>
          <AurDialog
            popupTitle="Welcome to the Dialog"
            popupContent="This disalog is the base for all dialogs in Aurora"
            labelActionOk="Ok"
            labelActionCancel="Cancel"
            onOk={modalOkClickHandler} // Pass the OK handler
            onCancel={modalCancelClickHandler} // Pass the Cancel handler
            showDialog={isVisible}
            buttonStyle="sideBySide"
          />
        </div>
      </div>
    </>
  );
};

export default Dialog;
